import createIcon from '@/lib/create-icon'

const WalletIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      d='M3 5.5C3 6.32843 3.67157 7 4.5 7H14M3 5.5V17C3 18.6569 4.34315 20 6 20H18C19.6569 20 21 18.6569 21 17V10C21 8.34315 19.6569 7 18 7H14M3 5.5C3 4.67157 3.67157 4 4.5 4H11C12.6569 4 14 5.34315 14 7M6 17H10M18 13.5C18 14.3284 17.3284 15 16.5 15C15.6716 15 15 14.3284 15 13.5C15 12.6716 15.6716 12 16.5 12C17.3284 12 18 12.6716 18 13.5Z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'WalletIcon'
)

export default WalletIcon
